export const missingPhoto = path => /missing\.png$/.test(path)
